{
    "button.copy": "ينسخ",
    "button.email": "البريد الإلكتروني",
    "button.share": "يشارك",
    "button.sms": "رسالة قصيرة",
    "footer.poweredBy": "بدعم من <linkText> Ice Cream Social <\/linkText>",
    "footer.privacyPolicy": "سياسة الخصوصية",
    "footer.termsAndConditions": "الأحكام والشروط",
    "offer.hint": "عندما {conversionGoal, plural, one {# صديق يجري عملية شراء } two {# الأصدقاء يجرون عمليات شراء } few {# أصدقاء يجرون عمليات شراء } many {# أصدقاء يجرون عمليات شراء } other {# أصدقاء يجرون عمليات شراء }} ، ستتلقى مكافأتك !",
    "optInMessage": "للمشاركة والمشاركة مع أصدقائك ، أخبرنا بكيفية الاتصال بك لتحديثات العروض والمكافآت",
    "order.confirmed": "تم تأكيد الطلب رقم {orderId} !",
    "order.details": "انظر تفاصيل الطلب",
    "share.email.duplicateError": "عذرًا! لقد قمت بالفعل بإضافة هذا البريد الإلكتروني.",
    "share.email.heading": "قم بدعوة الأصدقاء عن طريق البريد الإلكتروني",
    "share.email.inputLabel": "عنوان بريد صديقك",
    "share.email.inputSubmit": "يدخل",
    "share.email.invitesSubmit": "ارسل دعوات",
    "share.email.moreOptions": "المزيد من خيارات المشاركة",
    "share.email.subheading": "أدخل عناوين البريد الإلكتروني لأصدقائك أدناه",
    "share.general.help": "<bold> هل تواجه مشكلة؟ <\/bold> قد لا تفتح التطبيقات إذا لم تكن مثبتة على جهازك ، حاول استخدام <bold2> مشاركة <\/bold2> عن طريق رابطك الشخصي بدلاً من ذلك",
    "share.general.linkLabel": "استخدم رابطك الشخصي للمشاركة في أي مكان",
    "share.general.otherOptions": "أو شاركها الآن على هذه المنصات",
    "thankyou.dismissCTA": "رفض",
    "thankyou.heading": "شكرا للمشاركة!",
    "thankyou.message": "أنت بطل! سنرسل لك تحديثات بشأن تقدم مكافأتك إلى صندوق الوارد الخاص بك.",
    "thankyou.reminder": "ضع في اعتبارك أنه يمكنك دائمًا زيارة هذا العرض لاحقًا إذا كنت تريد متابعة المشاركة.",
    "thankyou.shareCTA": "تواصل المشاركة",
    "unlock.consentExplanation": "سنتواصل معك باستخدام المعلومات التي قدمتها. يمكنك إلغاء الاشتراك في أي وقت ، ولكن قد تفوتك التحديثات المتعلقة بعرضك",
    "unlock.consentPolicyExplanation": "نحن نقيم مستوى الخصوصية لديك. لمعرفة كيفية استخدام معلوماتك ، اقرأ <linkText> سياسة الخصوصية وملفات تعريف الارتباط <\/linkText>",
    "unlock.emailConsentOptIn": "أرسل لي التحديثات",
    "unlock.error.invalidEmail": "يرجى إدخال البريد الإلكتروني الصحيح",
    "unlock.error.noConsent": "يرجى الموافقة على اتصالات البريد الإلكتروني للمشاركة في هذا العرض",
    "unlock.input": "عنوان بريدك  الإلكتروني",
    "unlock.label": "تفعيل العرض",
    "share.general.copySuccess": "✨ تم نسخ الرابط!"
}